import { Flex } from 'antd';
import { EvidenceFileItem } from '@api/brokerCases/types';
import { EvidenceUploadedFileItem } from './EvidenceUploadedFileItem';

export interface IEvidenceUploadedFilesListProps {
  files: EvidenceFileItem[];
}

export const EvidenceUploadedFilesList = ({ files }: IEvidenceUploadedFilesListProps) => {
  return (
    <Flex vertical className='w-full gap-2'>
      {files.map(file => (
        <EvidenceUploadedFileItem key={file.id} file={file} />
      ))}
    </Flex>
  );
};
